import getISO2 from '@/transforms/iso-code'

// Normalize country codes (e.g., "USA" → "US") to match dropdown options
const normalizeCountryCode = (code) => {
  if (!code) return code
  return getISO2(code)
}

// Normalize country codes in order details payload
const normalizeOrderDetailsCountries = (payload) => {
  if (!payload || typeof payload !== 'object') return payload

  const normalized = { ...payload }

  // Normalize header billto/shipto countries
  if (normalized.header) {
    normalized.header = { ...normalized.header }
    if (normalized.header.billto) {
      normalized.header.billto = {
        ...normalized.header.billto,
        country: normalizeCountryCode(normalized.header.billto.country)
      }
    }
    if (normalized.header.shipto) {
      normalized.header.shipto = {
        ...normalized.header.shipto,
        country: normalizeCountryCode(normalized.header.shipto.country)
      }
    }
  }

  return normalized
}

// Normalize country codes in ship to update response
const normalizeShipToResponse = (payload) => {
  if (!payload || typeof payload !== 'object') return payload

  const normalized = { ...payload }

  if (normalized.body) {
    normalized.body = { ...normalized.body }
    if (normalized.body.billto) {
      normalized.body.billto = {
        ...normalized.body.billto,
        country: normalizeCountryCode(normalized.body.billto.country)
      }
    }
    if (normalized.body.shipto) {
      normalized.body.shipto = {
        ...normalized.body.shipto,
        country: normalizeCountryCode(normalized.body.shipto.country)
      }
    }
  }

  return normalized
}

export { normalizeOrderDetailsCountries, normalizeShipToResponse }
